<template>
  <div id="app">
    <div id="nav">
        <router-view style="min-height:100vh;" v-if="name == 'index' || name == 'Login' " />
         <!-- 公共头部与侧边栏 -->
        <el-container v-else>
            <!-- 侧边栏 :width="show ? '56px':'210px'" -->
            <el-aside width="210px">
                <ComSideMenu id="sideMenu"></ComSideMenu>
            </el-aside>
            <el-container>
                <el-header style="height:70px !important;">
                    <ComHeader></ComHeader>
                    <!-- <com-tabs></com-tabs> -->
                </el-header>
                <!-- 内容页 -->
                <el-main class="main" :style="'minHeight:' + Height + 'px;width:calc(100vh-210px);'">
                    <!-- <el-breadcrumb separator-class="el-icon-arrow-right" class="breadNav">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item v-for="(item,index) in breadList" :key="index" :to="{ path: item.path }">{{item.meta.title}}</el-breadcrumb-item>
                    </el-breadcrumb> -->
                    <router-view/>
                </el-main>
            </el-container>
            <!-- <el-footer><ComFooter></ComFooter></el-footer> -->
        </el-container>
    </div>
    <!-- <router-view/> -->
  </div>
</template>
<script>
import ComSideMenu from "@/components/ComSideMenu.vue";
import ComFooter from "@/components/ComFooter.vue";
import ComHeader from "@/components/ComHeader.vue";
import ComTabs from "@/components/ComTabs.vue"

export default {
    name: "App",
    data() {
        return {
            loding:'',
            Height: 0, // 主体内容高度
            property: 'value',
            name:'',
            breadList: [], // 面包屑导航
        };
    },
    watch:{
        $route(to,from){
            this.name = to.name;
           
        }
    },
    created(){
       
        
    },
    mounted () {
        //动态设置内容高度 让footer始终居底   header+footer的高度是120px
        this.Height = document.documentElement.clientHeight - 70; //监听浏览器窗口变化
        window.onresize = () => {
            this.Height = document.documentElement.clientHeight - 70;
        };

    },
    methods: {
       
        
    },
    components: {
        ComSideMenu,
        ComHeader,
        ComFooter,
        ComTabs
    },
};
</script>
<style lang="scss">
.main{
    // overflow: scroll;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
  min-width: 1349px;
}
.el-tooltip__popper {
    max-width: 800px;
  }
  .el-header{
    /* background:linear-gradient(to right,#AFD8F8,#C9B3E1); */
    /* background:linear-gradient(to right,#AFD8F8,#7886CA); */
    color: #333;
    text-align: center;
  }
//  ul{
//      list-style: none;
//  }
  .el-aside {
    // background:linear-gradient(to right,#AFD8F8,#7886CA);
    background: white;
    color: #333;
    text-align: center;
    position: relative;
    overflow: hidden;
  }
  .el-main {
    background-color: #f0f0f0;
    color: #333;
    /* text-align: center; */
    padding: 20px !important;
    // overflow:scroll;
    min-height: 1000px;
    overflow-x: hidden;
    overflow-y: hidden;

  }

  #sideMenu{
    width: 100%;
    height: 100%;
  }

  .breadNav{
    /* width: 96%; */
    /* height: 7%;
    line-height: 60px; */
    padding: 0 2%;
    /* border-bottom: 1px solid #ddd; */
  }
  .el-pagination {
    white-space: nowrap;
    padding: 2px 5px;
    color: #303133;
    font-weight: 700;
    text-align: center;
}

*{
    margin: 0;
    padding: 0;
    // background-color: #F3F3F3;
}
// #nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>
